"use strict";

import angular from "angular";

import template from "./empty-contract-accounting.component.html";
import "./themes/empty-contract-accounting.component.scss";
import "./themes/empty-contract-accounting.component-dark.scss";

import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";
import _ from "lodash";
import { Events } from "../../../presentation/services/Events/Events";
import { EmailSESService } from "../../../presentation/services/EmailSES/EmailSES";
import requestContractDialogTemplate from "../../dialogs/request-contract/request-contract-dialog.html";

export class EmptyContractAccountingComponent {
    Events = new Events();

    constructor(DSNDialogService) {
        this.DSNDialogService = DSNDialogService;
    }

    $onInit() {
        this.user = new UserDataAdapter().user();

        this.isAdmin = this.user.roles.includes("Contabilidade");

        this.buttonProps = !this.isAdmin
            ? false
            : { label: "Solicitar contato", icon: "fas fa-rocket" };
    }

    sendEmail() {
        if (publicSettings.environment != "production") return;

        const templateString = this.templateEmail({
            plan: this.accountingData.contract,
            hubspotId: _.get(this.accountingData, "hubspot._id"),
            accountingCode: _.get(this.accountingData, "superLogica._id"),
            feature: this.feature,
            userName: this.user.profile.nickname || this.user.profile.name,
            email: this.user.username
        });

        const senderEmail = new EmailSESService();

        const subject = `Solicitação de Feature: ${this.accountingData.name}`;

        senderEmail.sendBulk({
            subject: subject,
            to: [
                { name: "Hadna Esteves", email: "hadna.esteves@nucont.com" },
                {
                    name: "Giovanni Gontijo",
                    email: "giovanni.gontijo@nucont.com"
                },
                {
                    name: "Matheus Queiroga",
                    email: "matheus.queiroga@nucont.com"
                },
                {
                    name: "Fernando Pinheiro",
                    email: "fernando.pinheiro@nucont.com"
                },
                { name: "Thaina Souza", email: "thaina.souza@nucont.com" },
                { name: "Vinicius", email: "vinicius@nucont.com" }
            ],
            from: {
                name: "Nucont PRO",
                email: "nanda@nucont.com"
            },
            bodyOptions: {
                reference: "ComunicacaoInterna",
                defaultParams: {
                    subject: subject,
                    templateString
                }
            }
        });
    }

    requestContract($event) {
        this.Events.send(`Solicitacao.Feature.${this.feature}`);

        this.sendEmail();

        this.DSNDialogService.custom({
            targetEvent: $event,
            controller: "RequestContractDialogCtrl",
            controllerAs: "$ctrl",
            clickOutsideToClose: true,
            locals: {
                width: "450px",
                templateHtml: requestContractDialogTemplate
            },
            after: {}
        });
    }

    templateEmail({
        plan,
        hubspotId,
        accountingCode,
        feature,
        userName,
        email
    }) {
        return `

        <table
        style="
            font-family: Open Sans, sans-serif;
            width: 100%;
            color: #2e5573;
            font-size: 16px;
        "
    >
        <tbody>
            <tr>
                <td valign="top">
                    <table
                        cellpadding="0"
                        cellspacing="0"
                        border="0"
                        style="
                            height: 4px;
                            width: 100%;
                            background-color: #00cbd2;
                            margin-bottom: 24px;
                        "
                    >
                        <tbody>
                            <tr></tr>
                        </tbody>
                    </table>
                    <h1
                        style="
                            text-align: center;
                            font-size: 24px;
    
                            margin: 0;
    
                            font-family: Open Sans, sans-serif;
                        "
                    >
                        Solicitação de Feature
                    </h1>
                    <table
                        border="0"
                        cellpadding="0"
                        cellspacing="0"
                        width="100%"
                        style="
                            font-size: 0;
                            height: 30px;
                            width: 100%;
                            min-width: 100%;
                            line-height: 0;
                        "
                    >
                        <tbody>
                            <tr>
                                <td height="30">
                                    <span
                                        style="
                                            color: transparent;
                                            background: none;
                                            text-overflow: ellipsis;
                                            opacity: 0;
                                            width: 100%;
                                            min-width: 100%;
                                            height: 1;
                                            padding: 0;
                                            font-size: 0;
                                        "
                                    >
                                        &nbsp;</span
                                    >
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </td>
            </tr>
            <tr>
                <td>
                    <p><strong>Plano atual:</strong> ${plan}</p>
                    <p><strong>Feature solicitada:</strong> ${feature}</p>
                    <p>
                        <strong>Código no Hubspot:</strong> ${hubspotId}
                    </p>
                    <p><strong>Código da Nucont:</strong> ${accountingCode}</p>
                    <p>
                        <strong>Usuário:</strong>
                        ${userName} (${email})
                    </p>
                </td>
            </tr>
        </tbody>
    </table>
    
        `;
    }
}

EmptyContractAccountingComponent.$inject = ["DSNDialogService"];

const name = "emptyContractAccountingComponent";
const def = {
    controller: EmptyContractAccountingComponent,
    bindings: {
        isContract: "@",
        description: "@",
        feature: "@",
        accountingData: "<"
    },
    template
};
angular.module("nucont.shared").component(name, def);
export default { name, ...def };
